import { useState, useRef, useEffect } from 'react';
import TencentFilter from './tencentfilter';
import VideoScreenshotCapture from './videoscreenshotcapture';

/*
 * Thing that wires together TencentFilter, webcam input, and VideoScreenshotCapture,
 * as well as fetching authentication ...
 */
const originURL = "https://cbsfstagr2-f0f9fqhhd6enb7e6.eastus2-01.azurewebsites.net"

const FilterContainer = ({ beauty = {}, webcamConstraints = {}, screenshotFunctionRef, licenseUrl = originURL + "/api/tencent/tencent-license", signatureUrl = originURL + "/api/tencent/tencent-signature" }) => {
  const [authn, setAuthn] = useState(null);
  const [input, setInput] = useState(null);
  const [licenseFetchError, setLicenseFetchError] = useState(null);
  const theVideo = useRef(null);

  useEffect(() => {
    let ignore = false;

    // Fetch license keys
    // TODO: Should TencentFilter just take a URL (or a 'base' URL that gets preset endpoint names appended to it for license and signature) as to
    // consolidate everything that fetches from URL in one place?
    fetch(licenseUrl).then(res => {
      res.json().then((res) => { if (!ignore) setAuthn(res) }, rejectReason => {
        if (!ignore) setLicenseFetchError("json(): " + JSON.stringify(rejectReason));
      });
    }, rejectReason => {
      if (!ignore) setLicenseFetchError("fetch(): " + JSON.stringify(rejectReason));
    });

    // Get webcam input
    // TODO handle if there's an error or we never get the stream --- in final version, we may want to set something that stops the user from continuing with the study if this happens?
    // Possibly a retry mechanism? That might be more of a stretch goal though
    navigator.mediaDevices.getUserMedia(webcamConstraints)
      .then(stream => {
        if (!ignore) {
          setInput(stream);
        }
      }, rejectReason => {
        console.error("getMediaStream failed", rejectReason);
      });

    // Thing that tries to cancel the asynchronous side effects if React aborts the Effect
    return () => {
      ignore = true;
    };
  }, [licenseUrl, webcamConstraints]);

  // Thing that tries to tear down (stop) the webcam feed when the thing navigates away
  useEffect(() => {
    return () => {
      if (input) {
        console.log("stopping input tracks");
        input.getTracks().forEach((track) => {
          track.stop();
        });
        setInput(null);
      }
    }
  }, [input]);

  console.log("Tencent container states: ", licenseFetchError, authn);

  let tencent = <span>Loading...</span>;
  if (licenseFetchError != null) {
    tencent = <span>Error fetching keys needed to start Tencent filter:  {JSON.stringify(licenseFetchError)}</span>
  } else if (authn !== null) {
    console.log("Starting filter with ref", theVideo);
    tencent = <TencentFilter appId={authn.appid || null} licenseKey={authn.key || null} authUrl={signatureUrl} input={input} beautyParams={beauty} outputVideoRef={theVideo} />;
  }

  return (<>
    <video ref={theVideo}/>
    <VideoScreenshotCapture videoRef={theVideo} screenshotFunctionRef={screenshotFunctionRef}/>
    {tencent}
  </>);
}

export default FilterContainer;